import * as React from 'react';
import { Typography } from 'antd';
const { Title, Text, Paragraph } = Typography;
import { Link } from 'react-router-dom';
import { ISODate } from 'client/ui/display/date/ISODate';
import './RequestTableCellTitle.scss';
import { IRequest, RequestState } from 'common/schema/request/Request';
import { RequestStateTag } from '../status/RequestStateTag';
import { ResponsiveHide } from 'client/ui/responsive/ResponsiveHide';
import { RequestTableCellActions } from './RequestTableCellActions';
import { useTranslation } from 'react-i18next';
import { ProcedureLogic } from 'common/schema/ProcedureLogic';

export interface RequestTableCellTitleProps {
  request: IRequest;
}

export function RequestTableCellTitle(props: RequestTableCellTitleProps) {
  const { t } = useTranslation();

  return (
    <div className="request-table-cell-title">
      <div>
        <Paragraph className="request-tag-dates">
          <RequestStateTag status={props.request.state} />
          {props.request.state === RequestState.Sent ||
          props.request.state === RequestState.Cancelled ? (
            <span className="request-date">
              <Text type="secondary">
                {t('procedures.my.list.sent-date', 'Inviata il')}:{' '}
              </Text>
              <Text strong>
                <ISODate date={props.request.sentAt} />
              </Text>
            </span>
          ) : (
            <span className="request-date">
              <Text type="secondary">
                {t('procedures.my.list.created-at', 'Creata il')}:{' '}
              </Text>
              <Text strong>
                <ISODate date={props.request.createdAt} />
              </Text>
            </span>
          )}
        </Paragraph>
        <Title className="request-title" level={3}>
          {props.request.procedure.title}
        </Title>
        <Paragraph className="procedure-date">
          <span className="request-date">
            <Text type="secondary">
              {t('procedures.my.list.expires-date', 'Data Scadenza')}:{' '}
            </Text>
            <Text strong type="secondary">
              <ISODate
                date={ProcedureLogic.getRenderableDateWith24Hour(
                  props.request.procedure.expiresAt
                )}
              />
            </Text>
          </span>
        </Paragraph>
      </div>
      <ResponsiveHide mobileOnly>
        <div style={{ float: 'right', paddingTop: '8px' }}>
          <RequestTableCellActions request={props.request} />
        </div>
      </ResponsiveHide>
    </div>
  );
}
